export const HIDDEN_EMOJIS = [
  // perros
  "1f415-200d-1f9ba",
  "1f415-200d-1f9bc",
  "1f415-200d-1f9bd",
  "1f408-200d-2b1b",

  // Gatos
  "1f408-200d-1f9ba",
  "1f408-200d-1f9bc",
  "1f408-200d-1f9bd",

  //
  "1f43f-fe0f",
  "1f54A-fe0f",
  "1f3f5-fe0f",
  "1f3f6-fe0f",
  "1f3f7-fe0f",
  "1f3f8-fe0f",
  "1f3f9-fe0f",
  "1f3fa-fe0f",
  "1f3fB-fe0f",
  "1f577-fe0f",
  "1f578-fe0f",

  // Familias
  "1f468-200d-1f469-200d-1f467",
  "1f468-200d-1f469-200d-1f466",
  "1f468-200d-1f468-200d-1f466",
  "1f468-200d-1f468-200d-1f467",
  "1f469-200d-1f469-200d-1f466",
  "1f469-200d-1f469-200d-1f467",
  "1f468-200d-1f469-200d-1f467-200d-1f466",
  "1f468-200d-1f469-200d-1f466-200d-1f467",
  "1f468-200d-1f468-200d-1f467-200d-1f466",
  "1f469-200d-1f469-200d-1f467-200d-1f466",

  // Parejas con corazón y beso
  "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
  "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
  "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
  "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
  "1f468-200d-2764-fe0f-200d-1f468",
  "1f469-200d-2764-fe0f-200d-1f469",
  "1f469-200d-2764-fe0f-200d-1f468",

  // Personas dándose la mano
  "1f9d1-200d-1f91d-200d-1f9d1",
  "1f469-200d-1f91d-200d-1f468",
  "1f469-200d-1f91d-200d-1f469",
  "1f468-200d-1f91d-200d-1f468",
  "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
  "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",

  // Personas con barba (incluyendo mujer con barba)
  "1f9d4-200d-2640-fe0f",
  "1f9d4-200d-2642-fe0f",
  "1f9d4-1f3fb-200d-2640-fe0f",
  "1f9d4-1f3fc-200d-2640-fe0f",
  "1f9d4-1f3fd-200d-2640-fe0f",
  "1f9d4-1f3fe-200d-2640-fe0f",
  "1f9d4-1f3ff-200d-2640-fe0f",
  "1f9d4-1f3fb-200d-2642-fe0f",
  "1f9d4-1f3fc-200d-2642-fe0f",
  "1f9d4-1f3fd-200d-2642-fe0f",
  "1f9d4-1f3fe-200d-2642-fe0f",
  "1f9d4-1f3ff-200d-2642-fe0f",

  // Personas con género específico y profesiones
  "1f468-200d-2695-fe0f",
  "1f469-200d-2695-fe0f",
  "1f468-200d-1f393",
  "1f469-200d-1f393",
  "1f468-200d-1f3eb",
  "1f469-200d-1f3eb",
  "1f468-200d-1f3ed",
  "1f469-200d-1f3ed",
  "1f468-200d-1f4bb",
  "1f469-200d-1f4bb",
  "1f468-200d-1f4bc",
  "1f469-200d-1f4bc",
  "1f468-200d-1f527",
  "1f469-200d-1f527",
  "1f468-200d-1f52c",
  "1f469-200d-1f52c",
  "1f468-200d-1f680",
  "1f469-200d-1f680",
  "1f468-200d-1f692",
  "1f469-200d-1f692",
  "1f468-200d-1f9af",
  "1f469-200d-1f9af",
  "1f468-200d-1f9bc",
  "1f469-200d-1f9bc",
  "1f468-200d-1f9bd",
  "1f469-200d-1f9bd",

  // Personas caminando o corriendo con género
  "1f6b6-200d-2640-fe0f",
  "1f6b6-200d-2642-fe0f",
  "1f3c3-200d-2640-fe0f",
  "1f3c3-200d-2642-fe0f",
  "1f3c7-200d-2640-fe0f",
  "1f3c7-200d-2642-fe0f",

  // Banderas compuestas
  "1f3f3-fe0f-200d-1f308",
  "1f3f3-fe0f-200d-26a7-fe0f",
  "1f3f4-200d-2620-fe0f",
  "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
  "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
  "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",

  // Símbolos de género
  "26a7-fe0f",

  // Personas con bastón o silla de ruedas
  "1f9d1-200d-1f9af",
  "1f9d1-200d-1f9bc",
  "1f468-200d-1f9af",
  "1f469-200d-1f9af",
  "1f468-200d-1f9bc",
  "1f469-200d-1f9bc",

  // Personas embarazadas o lactando
  "1f930-200d-2640-fe0f",
  "1f930-200d-2642-fe0f",
  "1f930-1f3fb-200d-2640-fe0f",
  "1f930-1f3fc-200d-2640-fe0f",
  "1f930-1f3fd-200d-2640-fe0f",
  "1f930-1f3fe-200d-2640-fe0f",
  "1f930-1f3ff-200d-2640-fe0f",

  // Parejas con actividades específicas
  "1f468-200d-1f57a",
  "1f469-200d-1f57a",
  "1f3cb-fe0f-200d-2640-fe0f",
  "1f3cb-fe0f-200d-2642-fe0f",
  "1f3cc-fe0f-200d-2640-fe0f",
  "1f3cc-fe0f-200d-2642-fe0f",
];
